import { render, staticRenderFns } from "./files-notes.vue?vue&type=template&id=9db71f32&scoped=true&"
import script from "./files-notes.vue?vue&type=script&lang=js&"
export * from "./files-notes.vue?vue&type=script&lang=js&"
import style0 from "./files-notes.vue?vue&type=style&index=0&id=9db71f32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db71f32",
  null
  
)

export default component.exports